import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { storeToRefs } from 'pinia';

import { useCommonStore } from '@/store/common/index';

import PageGenerate from '@/components/pages/Generate/Generate.vue';
import PageInpaint from '@/components/pages/Inpaint/Inpaint.vue';
import PageOutpaint from '@/components/pages/Outpaint/Outpaint.vue';
import PageUpscale from '@/components/pages/Upscale/Upscale.vue';
import PageInfographics from '@/components/pages/Infographics/Infographics.vue';
import PageRemoveBackground from '@/components/pages/RemoveBackground/RemoveBackground.vue';
import PageShadow from '@/components/pages/Shadow/Shadow.vue';
import PageWatermarks from '@/components/pages/Watermarks/Watermarks.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComponentRouter',
  setup(__props) {

const { currentService } = storeToRefs(useCommonStore());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(currentService) === 'create_background_for_image')
      ? (_openBlock(), _createBlock(PageGenerate, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(currentService) === 'inpaint')
      ? (_openBlock(), _createBlock(PageInpaint, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(currentService) === 'outpaint')
      ? (_openBlock(), _createBlock(PageOutpaint, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(currentService) === 'upscale')
      ? (_openBlock(), _createBlock(PageUpscale, { key: 3 }))
      : _createCommentVNode("", true),
    (_unref(currentService) === 'infographics')
      ? (_openBlock(), _createBlock(PageInfographics, { key: 4 }))
      : _createCommentVNode("", true),
    (_unref(currentService) === 'remove_background')
      ? (_openBlock(), _createBlock(PageRemoveBackground, { key: 5 }))
      : _createCommentVNode("", true),
    (_unref(currentService) === 'shadow')
      ? (_openBlock(), _createBlock(PageShadow, { key: 6 }))
      : _createCommentVNode("", true),
    (_unref(currentService) === 'watermarks')
      ? (_openBlock(), _createBlock(PageWatermarks, { key: 7 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})